export interface JobDetailsSlice {
    readonly jobTitle: string;
    readonly jobId: number;
    readonly employmentType: string;
    readonly facilityId: number;
    readonly facilityName: string;
    readonly facilityLocation: string;
    readonly profession: string;
    readonly professionId: number | null;
    readonly specialtyId: number | null;
    readonly specialty: string;
    readonly unitId: number;
    readonly unitFormId: string;
    readonly unitDescription: string;
    readonly accountManager: string;
    readonly accountCoordinator: string;
    readonly billRate: number;
    readonly payPeriodTypesId?: number;
    readonly twentyFourHourCallBillRate?: number;
}

export const initialJobDetailsSlice: JobDetailsSlice = {
    jobTitle: '',
    jobId: 0,
    employmentType: '',
    facilityId: 0,
    facilityName: '',
    facilityLocation: '',
    profession: '',
    professionId: null,
    specialtyId: null,
    specialty: '',
    unitId: 0,
    unitFormId: '',
    unitDescription: '',
    accountManager: '',
    accountCoordinator: '',
    billRate: 0,
    payPeriodTypesId: null,
    twentyFourHourCallBillRate: null
};
